import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux"
import { getSortManagementList, editSortingManagement, getAllMachineCodes } from '../../../../actions/saActions';
import { Button, MenuItem, Paper, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddIcon from '@material-ui/icons/Add';
import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../../reducers/uiSlice';
import FullscreenLoading from '../../../../components/Common/FullscreenLoading';
import ConfigFilter from './ConfigFilter';

const useStyles = makeStyles((theme)=> ({
    zoneDetails: {
        marginTop: 5,
        border: '1px solid rgba(255, 255, 255, 0.5)',
        width: 310,
        borderRadius: 5,
        padding: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    addButton: { 
        marginLeft: 'auto', 
        marginRight: 'auto', 
        padding: 10,
        textAlign: 'center'
    },
    tableRowColor: { 
        background: '#212121' 
    },
    tableCellFormat: { 
        fontSize: '1.2rem', 
        textAlign: 'center' 
    },
    gridStyle: {
        marginRight: 10
    }
}))

function AllInOneConfigZone(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('slotAssignment');

    let branches = useSelector(state => state.common.branches);
    let slotManagementList = useSelector(state => state.saReducer.getSortManagementList);
    let allMachineCodes = useSelector(state => state.saReducer.getAllMachinesCodes);

    const configColumns = [
        {
            text: t('machine_code_table')
        },{
            text: t('target_warehouse')
        },{
            text: t('is_external')
        },{
            text: t('external_need_sorting')
        },{
            text: t('external_owner')
        }
    ]
    const configRows = [
        {
            id: 'machine_code',
            type: 'select',
            list: allMachineCodes.map((machine) => {
                machine.short_name=machine.machine_code;
                machine.id=machine.machine_code; 
                return machine
            }),
            required: true,
            contentType: 'Number'
        },{
            id: 'target_warehouse',
            type: 'select',
            list: branches,
            required: true,
            contentType: 'Number'
        },{
            id: 'is_external',
            type: 'select',
            list: [
                {
                    id: '0',
                    short_name: t('no')
                },{
                    id: '1',
                    short_name: t('yes')
                }
            ],
            required: true,
            contentType: 'Number'
        },{
            id: 'external_need_sorting',
            type: 'select',
            list: [
                {
                    id: '0',
                    short_name: t('no')
                },{
                    id: '1',
                    short_name: t('yes')
                }
            ],
            contentType: 'Number'
        },{
            id: 'external_owner',
            type: 'input',
            contentType: 'String'
        }
    ]

    const [openConfigAddModal, setOpenConfigAddModal] = useState(false);
    const [openConfigModal, setOpenConfigModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState('view');
    const [newlyAdded, setNewlyAdded] = useState({});
    const [edited, setEdited] = useState([]);
    const [listFiltered, setListFiltered] = useState(slotManagementList);
    const [listFilteredByBranch, setListFilteredByBranch] = useState(slotManagementList);

    const handleClickOpenAdd = () => {
        setNewlyAdded({});
        setOpenConfigAddModal(true);
    };
    const handleOpen = (type) => {
        setType(type);
        setOpenConfigModal(true);
    }
    const handleClose = () => {
        setOpenConfigModal(false);
    }
    const handleNewlyAdded = (element, value) => {
        setNewlyAdded((prev) => ({
            ...prev,
            [element]: value + ''
        }))
    }
    const handleEdited = (managementId, key, value) => {
        let temp = {
            id: managementId,
            params: slotManagementList.find(slot => slot.id===managementId) || {}
        }
        temp['params'][key] = value;
        temp['params']['management_id'] = managementId;
        setEdited((prev) => ({
            ...prev,
            [temp.id]: temp.params
        }))
    }
    const handleSave = (managementId) => {
        let params = !openConfigAddModal ? edited[managementId] : newlyAdded;
        Object.keys(params).forEach(key => {
            params[key] = params[key] + '';
          });
        if(validateParams(params)) {
            setLoading(true);
            dispatch(editSortingManagement(params))
            .then(() => {
                if(!openConfigAddModal) {
                    setEdited([]);
                }
                dispatch(showAlertSnackbar({message:t('edited_save_success'),type:"success"}))
                dispatch(getSortManagementList())
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message:err.message||t('edited_save_fail'),type:"error"}))
            })
            .finally(() => {
                setLoading(false);
                setOpenConfigAddModal(false);
            })
        }
    }
    const validateParams = (management) => {
        if(!management['machine_code'] || !management['is_external'] || !management['target_warehouse']) {
            dispatch(showAlertSnackbar({message:t('required_first_tier'),}))
            return false;
        }
        if(management['is_external'] === '1') {
            if(!management['external_need_sorting']) {
                dispatch(showAlertSnackbar({message:t('required_second_tier')}))
                return false;
            }
        }
        if(management['external_need_sorting'] === '1') {
            if(!management['external_owner']) {
                dispatch(showAlertSnackbar({message:t('required_third_tier')}))
                return false;
            }
        }
        return true;
    }
    const init = () => {
        let promises = [
            dispatch(getAllMachineCodes()),
            dispatch(getSortManagementList())
        ];
        setLoading(true);
        Promise.all(promises)
        .catch(()=> {
            dispatch(showAlertSnackbar({message:t('fetch_failure'),type:'error'}))
        })
        .finally(() => {
            setLoading(false);
        })
    }
    const handleFilter = (filter) => {
        if(listFilteredByBranch?.length > 0) {
            let filterMachineCode = filter.machine_code;
            let filterTargetWarehouse = filter.target_warehouse;
            let filtered = listFilteredByBranch.filter((item) => {
                let machineCode = item.machine_code;
                let targetWarehouse = item.target_warehouse;
                if(machineCode?.toString() === filterMachineCode?.toString() || filterMachineCode?.toString() === '-1') {
                    if(targetWarehouse?.toString() === filterTargetWarehouse?.toString()) {
                        return item;
                    } else if(filterTargetWarehouse?.toString() === '-1') {
                        return item;
                    }
                }
                if(targetWarehouse?.toString() === filterTargetWarehouse?.toString() || filterTargetWarehouse?.toString() === '-1') {
                    if(machineCode?.toString() === filterMachineCode?.toString()) {
                        return item;
                    } else if(filterMachineCode === '-1') {
                        return item;
                    }
                }
            })
            setListFiltered(filtered);
        }
    }

    useEffect(() => {
        if(openConfigModal) {
            setEdited([]);
            init();
        }
    }, [openConfigModal])
    useEffect(() => {
        let filtered = slotManagementList.filter((item) => 
            item.sorting_center === props.branch
        )
        setListFiltered(filtered);
        setListFilteredByBranch(filtered);
    }, [slotManagementList, props.branch])

    return (
        <Paper color="text.primary" style={{marginTop:20}}>
            <div>{t('all_in_one_config_edit')}</div>
            <div className={classes.zoneDetails}>
                <div>{t('all_in_one_config')}</div>
                <div>
                    <Button
                        style={{ marginRight: 5}}
                        variant="contained" 
                        color="primary" 
                        onClick={()=>handleOpen('view')}
                    >
                        {t('view')}
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={()=>handleOpen('edit')}
                    >
                        {t('edit')}
                    </Button>
                </div>
            </div>
            <Dialog
                open={openConfigModal}
                onClose={handleClose}
                style={{ padding: 30 }}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle>{t('all_in_one_config')}</DialogTitle>
                <DialogContent>
                    <TableContainer component={Paper}>
                        <ConfigFilter 
                            filterRows={
                                [
                                    configRows[0], 
                                    configRows[1]
                                ]
                            }
                            handleFilter={handleFilter}
                        />
                        <Table>
                            <TableHead>
                                <TableRow className={classes.tableRowColor}>
                                    {
                                        configColumns.map((column) => (
                                            <TableCell align="center" className={classes.tableCellFormat} key={column.id}>{column.text}</TableCell>
                                        ))
                                    }
                                    {
                                        type === 'edit' &&
                                        <TableCell align="center" className={classes.tableCellFormat}>{t('save')}</TableCell>
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {
                                listFiltered?.length > 0 &&
                                listFiltered.map((row, index) => (
                                <TableRow
                                    key={row.id}
                                    style={ index % 2? { background : "#424242" }:{ background : "#303030" } }
                                >
                                    {
                                        configRows.map((element) => (
                                            <TableCell align="center" key={element.id}>
                                                {
                                                    type === 'view' ?
                                                    (
                                                        element.type === 'select' ?
                                                        <div>{element?.list.find((item) => item.id + '' === row[element.id] + '')?.short_name||row[element.id]}</div>
                                                        :
                                                        <div>{row[element.id]}</div>
                                                    )
                                                    :
                                                    (
                                                        element.type === 'select' ?
                                                        <TextField
                                                            select
                                                            variant="outlined"
                                                            value={edited[row.id]?edited[row.id][element.id]:row[element.id]}
                                                            onChange={(e)=>handleEdited(row.id, element.id, e.target.value)}
                                                        >
                                                        {
                                                            element.list.map((item) => (
                                                                <MenuItem value={item.id} key={item.id}>{item.short_name}</MenuItem>
                                                            ))
                                                        }
                                                        </TextField>
                                                        :
                                                        <TextField
                                                            variant="outlined"
                                                            onChange={(e)=>{handleEdited(row.id, element.id, e.target.value)}}
                                                            value={edited[row.id]?edited[row.id][element.id]:row[element.id]}
                                                        />
                                                    )
                                                }
                                            </TableCell>
                                        ))
                                    }
                                    {
                                        type === 'edit' &&
                                        <TableCell align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                disabled={!edited[row.id]}
                                                onClick={()=>handleSave(row.id)}
                                            >
                                                {t('save')}
                                            </Button>
                                        </TableCell>
                                    }
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {
                        type === 'edit' &&
                        <ListItem autoFocus className={classes.addButton} button onClick={handleClickOpenAdd} align='center'>
                            <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                <ListItemAvatar>
                                    <Avatar>
                                        <AddIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <div>{t('create_slot_management')}</div>
                            </div>                            
                        </ListItem>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {t('close')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openConfigAddModal}
                maxWidth="lg"
                fullWidth
            >
                <DialogContent dividers>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow className={classes.tableRowColor}>
                                    {
                                        configColumns.map((column) => (
                                            <TableCell align="center" className={classes.tableCellFormat} key={column.id}>{column.text}</TableCell>
                                        ))
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow style={{ background : "#303030" }}>
                                    {
                                        configRows.map((element) => (
                                            <TableCell align="center">
                                                {
                                                    element.type === 'select' ?
                                                    <TextField
                                                        select
                                                        variant="outlined"
                                                        onChange={(e)=>{handleNewlyAdded(element.id, e.target.value)}}
                                                        value={newlyAdded[element.id]}
                                                    >
                                                    {
                                                        element.list.map((item) => (
                                                            <MenuItem value={item.id} key={item.id}>{item.short_name}</MenuItem>
                                                        ))
                                                    }
                                                    </TextField>
                                                    :
                                                    <TextField
                                                        variant="outlined"
                                                        onChange={(e)=>{handleNewlyAdded(element.id, e.target.value)}}
                                                        value={newlyAdded[element.id]}
                                                    />
                                                }
                                                {
                                                    element.required &&
                                                    <span
                                                        style={{color: 'red',fontSize:24, marginLeft:5}}
                                                    >
                                                        *
                                                    </span>
                                                }
                                            </TableCell>
                                        ))
                                    }
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                <Button color="primary" onClick={()=>setOpenConfigAddModal(false)}>
                    {t('cancel')}
                </Button>
                <Button color="primary" onClick={handleSave}>
                    {t('assign')}
                </Button>
                </DialogActions>
            </Dialog>
            <FullscreenLoading open={loading} />
        </Paper>
    );
}

export default AllInOneConfigZone;